import { DATA_GENERATION_LIST, DATA_GENERATION_LIST_ERROR, DATA_GENERATION_LIST_SUCCESS, EDIT_FILTER_CONFIG, EDIT_FILTER_CONFIG_ERROR, EDIT_FILTER_CONFIG_SUCCESS, WELL_ALGORITHM_INFO_CREATE, WELL_ALGORITHM_INFO_CREATE_ERROR, WELL_ALGORITHM_INFO_CREATE_SUCCESS, WELL_ALGORITHM_INFO_DELETE, WELL_ALGORITHM_INFO_DELETE_ERROR, WELL_ALGORITHM_INFO_DELETE_SUCCESS, WELL_ALGORITHM_INFO_UPDATE, WELL_ALGORITHM_INFO_UPDATE_DATA, WELL_ALGORITHM_INFO_UPDATE_ERROR, WELL_ALGORITHM_INFO_UPDATE_SUCCESS } from './constants';

export default function wellAlgorithmInfoReducer(state, action) {
	switch (action.type) {
	
	case WELL_ALGORITHM_INFO_UPDATE_DATA :
		return { ...state, wellalgorithmUpdateData : action.payload };
	case WELL_ALGORITHM_INFO_UPDATE :
		return { ...state, loading : true, error : false};
	case WELL_ALGORITHM_INFO_UPDATE_SUCCESS :
		return { ...state, loading : false, error : false};
	case WELL_ALGORITHM_INFO_UPDATE_ERROR : 
		return { ...state, loading : false, error : true};
	case WELL_ALGORITHM_INFO_CREATE:
		return { ...state, loading : true, error : false };
	case WELL_ALGORITHM_INFO_CREATE_SUCCESS :
		return { ...state, loading : false, error : false};
	case WELL_ALGORITHM_INFO_CREATE_ERROR :
		return { ...state, loading : false, error : true };
	case WELL_ALGORITHM_INFO_DELETE :
		return { ...state, loading : true, error : false};
	case WELL_ALGORITHM_INFO_DELETE_SUCCESS :
		return { ...state, loading : false, error : false };
	case WELL_ALGORITHM_INFO_DELETE_ERROR :
		return { ...state, loading : false, error : true };

	case EDIT_FILTER_CONFIG :
		return {...state, loading : true , error : false};
	case EDIT_FILTER_CONFIG_SUCCESS :
		return {...state, loading : false , error : false};
	case EDIT_FILTER_CONFIG_ERROR :
		return {...state, loading : false , error : true};

	case DATA_GENERATION_LIST:
		return {...state, loading : false , error : false};
	case DATA_GENERATION_LIST_SUCCESS:
		// if (action.payload && action.payload && action.payload.length > 0) {
		// 	action.payload.map( (item) => {
		// 		let data = {};                        
		// 		data.id = item.id ? item.id : 0;
		// 		data.name = item.name;
		// 		data.configs = item && item?.configs;
		// 		return datageneration.push(data);
		// 	});
		// }
		return { ...state, datageneration:action.payload ,  loading: false, error: false };
	case DATA_GENERATION_LIST_ERROR:
		return {...state, loading : false , error : true};
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}